import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core'

@Component({
    selector: 'keycom-nav-button',
    templateUrl: './nav-button.component.html',
    styleUrls: ['./nav-button.component.scss'],
    standalone: false
})
export class NavButtonComponent implements OnInit {
  @Input() condition: Boolean
  @Input() content: String
  @Input() disabled: Boolean
  @Input() warn: Boolean
  @Input() small: Boolean
  @Input() outline: Boolean
  @Input() icon: String
  @Input() iconLeft: Boolean
  @Input() btnLeft: Boolean
  @Input() clear: Boolean
  @Input() aria: String
  @Input() chip: boolean

  @Input() collapsed: boolean
  @Input() active: boolean

  @Output() onClick: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  click() {
    this.onClick.emit()
  }
}
